<ul *ngIf="!isBottom" class="nav nav-tabs justify-content-end my-2">
  <li *ngIf="title.length" [class]="'nav-item flex-fill' + (control ? ' form-check form-switch ' : ' ') + titleAlign + ' my-0'" [attr.role]="isCollapse ? 'button' : undefined" (click)="onExpandClick()">
    <input *ngIf="control" class="form-check-input switch-sm" type="checkbox" [formControl]="formControl" #checkbox [id]="generatedId(title)" (change)="onChange($event)">
    <i *ngIf="icon?.length" [class]="icon"></i>
    <span [class]="'h6 ms-1 ' + (isBold ? 'fw-bold' : '')" [class.small]="isSmall">{{title}}</span>
    <i *ngIf="labelInfo?.length" class="bi bi-info-circle label-info text-muted ms-1" data-bs-toggle="tooltip" data-bs-placement="top" title="{{labelInfo}}"></i>
  </li>
  <li *ngIf="button">
    <i [class]="button.icon" role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="{{button.hint || button.label || ''}}" (click)="onButtonClick()"></i>
    {{button.label || ""}}
  </li>
  <li *ngIf="isCollapse">
    <i [class]="'bi ' + (collapsed ? 'bi-arrow-down-circle' : 'bi-arrow-up-circle')" role="button" (click)="onExpandClick()"></i>
  </li>
</ul>
<div [class]="class" [class]="margin ? 'pb-' + margin : undefined" [class.separator-background]="!isTransparent" [class.d-none]="isCollapsed">
  <ng-content></ng-content>
</div>
<ul *ngIf="isBottom" class="nav nav-tabs justify-content-end my-2">
  <li *ngIf="title.length" [class]="'nav-item flex-fill ' + titleAlign + ' my-0'" [attr.role]="isCollapse ? 'button' : undefined" (click)="onExpandClick()">
    <input *ngIf="control" class="form-check-input switch-sm" type="checkbox" [formControl]="formControl" #checkbox [id]="generatedId(title)" (change)="onChange($event)">
    <i *ngIf="icon?.length" [class]="icon"></i>
    <span [class]="'h6 ms-1 ' + (isBold ? 'fw-bold' : '')" [class.small]="isSmall">{{title}}</span>
    <i *ngIf="labelInfo?.length" class="bi bi-info-circle label-info text-muted ms-1" data-bs-toggle="tooltip" data-bs-placement="top" title="{{labelInfo}}"></i>
  </li>
  <li *ngIf="button">
    <i [class]="button.icon" role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="{{button.hint || button.label || ''}}" (click)="onButtonClick()"></i>
    {{button.label || ""}}
  </li>
  <li *ngIf="isCollapse">
    <i [class]="'bi ' + (collapsed ? 'bi-arrow-up-circle' : 'bi-arrow-down-circle')" role="button" (click)="onExpandClick()"></i>
  </li>
</ul>